// extracted by mini-css-extract-plugin
export default {"inputDiv":"renameModal_inputDiv__AfwDQ","buttonDiv":"renameModal_buttonDiv__LaGxW","okButton":"renameModal_okButton__bGZZH","cancelBtn":"renameModal_cancelBtn__fWipS"};